module.exports = __webpack_public_path__ + "static/media/coreLearning2.b03b4cd5.webp";